/**
 * @generated SignedSource<<c965c2c8b5b8a962a6d43a8b0b796cad>>
 * @relayHash 737a60122b0a1fbdaa4709876ac5fba5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea

import type { ConcreteRequest } from 'relay-runtime';
export type ChangeEditionClearRestrictionsForFreeMutation$variables = {
  contentId: string;
};
export type ChangeEditionClearRestrictionsForFreeMutation$data = {
  readonly clearRestrictionsForFree: {
    readonly restrictionsHash: string | null;
  } | null;
};
export type ChangeEditionClearRestrictionsForFreeMutation = {
  response: ChangeEditionClearRestrictionsForFreeMutation$data;
  variables: ChangeEditionClearRestrictionsForFreeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentRestrictionsPageResponse",
    "kind": "LinkedField",
    "name": "clearRestrictionsForFree",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "restrictionsHash"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ChangeEditionClearRestrictionsForFreeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangeEditionClearRestrictionsForFreeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "737a60122b0a1fbdaa4709876ac5fba5",
    "id": "f28965208d5e300780b488da945a8c46ef96b505c2ea6e19d9e29b5a2290d1ea",
    "metadata": {},
    "name": "ChangeEditionClearRestrictionsForFreeMutation",
    "operationKind": "mutation",
    "text": "mutation ChangeEditionClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}"
  }
};
})();

(node as any).hash = "a6f31038cfbb195a7ec707513d6d3235";

export default node;
